// extracted by mini-css-extract-plugin
module.exports = {"svgContent":"CanvasSVGObjectView_svgContent__3Xgq-","canvasSvgContent":"CanvasSVGObjectView_canvasSvgContent__QtuoX"};